import axiosClient from "../../../../axiosClient"

const service = async () => {
    const result = await axiosClient.get("/company")
    return result.data.name
}

export default service
